export const cleanString = (str: string) => (str ? str.replaceAll(/\D/g, '') : str);
